module.exports = __webpack_public_path__ + "13126142cec99a01fa831adaef26f5e8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-14.png
// module id = 2039
// module chunks = 0